import { render, staticRenderFns } from "./generatereports.vue?vue&type=template&id=64aa9a78&scoped=true"
import script from "./generatereports.vue?vue&type=script&lang=js"
export * from "./generatereports.vue?vue&type=script&lang=js"
import style0 from "./generatereports.vue?vue&type=style&index=0&id=64aa9a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa9a78",
  null
  
)

export default component.exports